import { Component, OnInit, OnDestroy } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { takeWhile } from 'rxjs/operators';
import { Location } from '@angular/common';

/**
 * Componente que renderiza la autenticación en la app
 */
@Component({
  selector: 'ngx-smart-rural-auth-comp',
  templateUrl: './smart-rural-auth-comp.component.html',
  styleUrls: ['./smart-rural-auth-comp.component.scss']
})
export class SmartRuralAuthCompComponent implements OnInit, OnDestroy {

  private alive = true;

  subscription: any;

  authenticated: boolean = false;
  token: string = '';

  // showcase of how to use the onAuthenticationChange method
  constructor(protected auth: NbAuthService, protected location: Location) {

    this.subscription = auth.onAuthenticationChange()
      .pipe(takeWhile(() => this.alive))
      .subscribe((authenticated: boolean) => {
        this.authenticated = authenticated;
      });
  }

  /**
   * REgresa a la página anterior
   * @returns
   */
  back() {
    this.location.back();
    return false;
  }

  /**
   * @ignore
   */
  ngOnDestroy(): void {
    this.alive = false;
  }

  /**
   * @ignore
   */
  ngOnInit(): void {
  }

}
